import { isEmpty } from 'lodash';
import { OrderSearchActions } from '../pages/Orders/store/slice/OrdersSlice';
import { doSearchStoreActionHandler as orderSearchAction } from '../pages/Orders/store/action/OrdersActions';
import { orderRequestActions } from '../pages/OrderRequest/store/slice/OrderRequestSlice';
import { doSearchStoreActionHandler as orderRequestSearchAction } from '../pages/OrderRequest/store/action/OrderRequestActions';
import { cylinderSearchActions } from '../pages/cylinders/store/slices/cylinderSearchSlice';
import { doSearchStoreActionHandler as cylinderSearchAction } from '../pages/cylinders/store/actions/cylinderSearchActions';

export const PageName = {
  Orders: 'Order',
  OrderRequest: 'OrderRequest',
  Cylinders: 'Cylinder',
  NotificationTemplates: 'Notification Template',
  Dashboard: 'dashboard',
};
export const actionMap = {
  Orders: {
    applySavedFilter: OrderSearchActions.applySavedFilter,
    doSearch: orderSearchAction,
    updateFilterValue: OrderSearchActions.updateFilterValue,
  },
  OrderRequest: {
    applySavedFilter: orderRequestActions.applySavedFilter,
    doSearch: orderRequestSearchAction,
    updateFilterValue: orderRequestActions.updateFilterValue,
  },
  Cylinders: {
    applySavedFilter: cylinderSearchActions.applySavedFilter,
    doSearch: cylinderSearchAction,
    updateFilterValue: cylinderSearchActions.updateFilterValue,
  }
};
export const getClientIdsByScreenAccess = (data, pageName) => data
  .filter((item) => {
    if (!item.OverrideRoleSetting) return false;
    const overrideSettings = JSON.parse(item.OverrideRoleSetting);
    const pageNameKey = PageName[pageName] ?? pageName;
    return overrideSettings.some((setting) =>
      setting.Text.toLowerCase() === pageNameKey.toLowerCase());
  })
  .map((record) => JSON.parse(record.Group1).ID);

export const getClientIdsScreenAccessByState = (state, pageName) => {
  const userToRoles = state?.auth?.loginUser?.userToRoles || [];
  return getClientIdsByScreenAccess(userToRoles, pageName);
};
export const getClientIdsScreenAccessByData = (data, pageName) => getClientIdsByScreenAccess(data, pageName);

export const transformToClientAccessList = (clientArray, reportArray, scenarioArray) => {
  if (isEmpty(clientArray) && isEmpty(reportArray) && isEmpty(scenarioArray)) return null;
  // Validate inputs
  const clients = Array.isArray(clientArray) ? clientArray : [];
  const reports = Array.isArray(reportArray) ? reportArray : [];
  const scenarios = Array.isArray(scenarioArray) ? scenarioArray : [];

  const clientMap = new Map();

  // Check if client array is empty
  if (isEmpty(clients)) {
    // Create default entry with null ClientID
    clientMap.set('null', {
      ClientID: null,
      AccessibleScenarioIDs: [],
      AccessibleReportAddressIDs: []
    });
  } else {
    // Initialize map with all clients
    clients.forEach((client) => {
      const clientID = client.ClientID || client.id;
      if (clientID) {
        clientMap.set(String(clientID), {
          ClientID: clientID,
          AccessibleScenarioIDs: [],
          AccessibleReportAddressIDs: []
        });
      }
    });
  }

  // Process scenarios
  scenarios.forEach((scenario) => {
    const clientID = scenario.ClientID ? String(scenario.ClientID) : 'null';
    if (clientMap.has(clientID)) {
      const scenarioID = scenario.id;
      if (scenarioID && !clientMap.get(clientID).AccessibleScenarioIDs.includes(scenarioID)) {
        clientMap.get(clientID).AccessibleScenarioIDs.push(scenarioID);
      }
    } else if (clients.length === 0) {
      // If no clients exist, add to null entry
      const scenarioID = scenario.id;
      if (scenarioID && !clientMap.get('null').AccessibleScenarioIDs.includes(scenarioID)) {
        clientMap.get('null').AccessibleScenarioIDs.push(scenarioID);
      }
    }
  });

  // Process reports
  reports.forEach((report) => {
    const clientID = report.ClientID ? String(report.ClientID) : 'null';
    if (clientMap.has(clientID)) {
      const reportID = report.id;
      if (reportID && !clientMap.get(clientID).AccessibleReportAddressIDs.includes(reportID)) {
        clientMap.get(clientID).AccessibleReportAddressIDs.push(reportID);
      }
    } else if (clients.length === 0) {
      // If no clients exist, add to null entry
      const reportID = report.id;
      if (reportID && !clientMap.get('null').AccessibleReportAddressIDs.includes(reportID)) {
        clientMap.get('null').AccessibleReportAddressIDs.push(reportID);
      }
    }
  });

  // Convert map to array and sort by ClientID
  const clientAccessList = Array.from(clientMap.values());
  return {
    ClientAccessList: clientAccessList
  };
};
export const getCommonClientOfGlobalFilterAndScreenAccess = (data, pageName, clientIds) => {
  try {
    const pageNameKey = PageName[pageName] ?? pageName;
    const assignedClientIds = data
      .filter((item) => {
        if (!item.OverrideRoleSetting) return false;
        try {
          const overrideSettings = JSON.parse(item.OverrideRoleSetting);
          return Array.isArray(overrideSettings) && overrideSettings.some(
            (setting) => setting?.Text?.toLowerCase() === pageNameKey.toLowerCase()
          );
        } catch {
          return false; // Skip records with invalid JSON
        }
      })
      .map((record) => {
        try {
          const groupData = JSON.parse(record.Group1);
          return groupData?.ID;
        } catch {
          return null; // Skip invalid records
        }
      })
      .filter(Boolean); // Remove null/undefined values
    const filteredClientIds = assignedClientIds.filter((id) => clientIds.includes(id));
    return clientIds.length > 0 ? filteredClientIds : assignedClientIds;
  } catch (error) {
    console.error('Error in getClientIdsByScreenAccess:', error);
    return [];
  }
};

export const hasScreenAccess = (data, pageName) => {
  const clientIds = getClientIdsByScreenAccess(data, pageName);
  return Array.isArray(clientIds) && clientIds.length > 0;
};
